<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal
      title="LIA"
      subtitle="This is a list matched and applied LIA"
      btnlefttext="Close"
      btncentertext=""
      btnrighttext=""
      :leftloading="false"
      :rightloading="false"
      :centerloading="false"
      :footerhidden="false"
      footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px"
      body_padding="30px 30px"
      width="550px"
      @onLeftClick="onCancel"
    >
      <div class="widget-modal-body-noscoll">
        <internshipItem
          v-for="(item, index) in user.applied_internships"
          :item="item"
          :key="index"
          :index="index"
          :matched="item.id == user.internship_id"
          :show_option="false"
          :isCheckBox="false"
          :isInArchive="false"
          :showCandidate="false"
          :tab_section="''"
          type="school"
        >
        </internshipItem>
      </div>
    </widgetModal>
  </div>
</template>
<script>
import internshipItem from "@/views/internship/components/internship_item.vue";
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  components: {
    internshipItem,
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.page-modal {
  .widget-modal-body-noscoll {
    max-height: 500px;
    overflow-y: auto;
    .applied-internship {
      margin-bottom: 20px;
    }
  }
}
</style>